<template>
  <div>
    <Registerlayout>
      <h5 class="text-center">Tourist Registration</h5>
      <form @submit.prevent="register()" class action="/register" method="post">
        <div class="form-group">
          <label>Your Name</label>
          <input class="form-control" v-model="name" type="text" />
          <i class="ti-user"></i>
        </div>
        <!--div class="form-group">
          <label>Shop Name</label>
          <input class="form-control" v-model="company_name" type="text" />
          <i class="ti-user"></i>
        </div-->
        <div class="form-group">
          <label>Your Email</label>
          <input class="form-control" v-model="email" type="email" />
          <i class="icon_mail_alt"></i>
        </div>
        <div class="form-group">
          <label>Your Phone</label>
          <input
            class="form-control"
            v-model="phone_no"
            type="text"
            maxlength="10"
          />
          <i class="icon-mobile"></i>
        </div>
        <div class="form-group">
          <label>PIN/Localization</label>
          <vue-simple-suggest
            v-model="pincode"
            display-attribute="name"
            value-attribute="url"
            :list="getSuggestionList"
            @select="get($event)"
          ></vue-simple-suggest>
          <i class="icon-map"></i>
        </div>
        <div class="form-group">
          <label>Your Address (optional)</label>
          <textarea
            class="form-control"
            v-model="address"
            id="address"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Your password</label>
          <input
            class="form-control"
            type="password"
            v-model="password"
            id="password1"
          />
          <i class="icon_lock_alt"></i>
        </div>

        <div class="form-group">
          <label>Confirm password</label>
          <input
            class="form-control"
            type="password"
            v-model="password_confirm"
            id="password2"
          />
          <i class="icon_lock_alt"></i>
        </div>
        <alert v-if="msg" :msg="msg" :classAlert="classAlert"></alert>

        <div id="pass-info" class="clearfix"></div>
        <button
          type="submit"
          class="btn_1 rounded full-width add_top_30"
          :disabled="loading"
        >
          <span
            v-show="loading"
            class="spinner-border spinner-border-sm"
          ></span>
          Register Now!
        </button>
        <div class="text-center add_top_10">
          Already have an acccount?
          <!-- <strong><a href="login.html">Sign In</a></strong> -->
          <router-link to="/signin"><strong>Sign In!</strong></router-link
          ><br />
          Are you a merchant??
          <router-link to="/merchant-signup"
            ><strong>Register here</strong></router-link
          >
        </div>
      </form>
    </Registerlayout>
  </div>
</template>

<script>
import Alert from "../cmps/Alert";
import API from "../services/index";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
//import router from "../routes";
import Registerlayout from "../layouts/Registerlayout.vue";
export default {
  data() {
    return {
      name: "",
      //company_name: "",
      email: "",
      password: "",
      phone_no: "",
      password_confirm: "",
      role_id: "3",
      msg: null,
      classAlert: null,
      pincode: "",
      address: "",
      loading: false,
      geocodes: [],
    };
  },
  methods: {
    // acceptNumber() {
    //   var x = this.phone_no.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    //   this.phone_no = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    // },
    getSuggestionList() {
      var i = [];
      if (this.pincode.length >= 2) {
        return API.get(`https://location.securebrandtech.com/auto/api?q=${this.pincode}`)
          .then(function (response) {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];
            return uniq;
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
    get(value) {
      var i = [];
      API.get(`https://location.securebrandtech.com/auto/api?q=${value}`)
        .then(function (response) {
          response.data.features.forEach(function (feature) {
            i.push(feature.geometry.coordinates);
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      setTimeout(() => {
        this.geocodes = i;
      }, 2000);
    },
    register() {
      this.loading = true;
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      if (this.phone_no.length != 10) {
        Toast.fire({
          icon: "Error",
          title: "phone number should be of 10 digits",
        });
        this.loading = false;
        return false;
      }
      if(this.geocodes.length === 0){
         Toast.fire({
          icon: "Error",
          title: "Please Select Location List Option ",
        });
        this.loading = false;
        return false;
      }
      console.log(this.geocodes)
      const form = new FormData();1
      form.append("first_name", this.name);
      //form.append("company_name", this.company_name);
      form.append("primary_email", this.email);
      form.append("password", this.password);
      form.append("mobile_1", this.phone_no);
      form.append("pincode", this.pincode);
      form.append("lat", this.geocodes);
      form.append("address", this.address);

      form.append("password_confirm", this.password_confirm);
      form.append("role_id", this.role_id);

      API.post("/user/register", form).then((res) => {
        this.loading = false;
        console.log(res.data.status);

        if (res.data.status == 200) {
          Toast.fire({
            icon: "Success",
            title: res.data.messages,
          });
          this.loading = true;
          this.$router.push(`/verify/${window.btoa(this.email)}`);
          
          // .catch((err) => {
          //   this.loading = false;
          //   Toast.fire({
          //     icon: "Error",
          //     title: err.response.data.error_description,
          //   });
          //this.$swal("Error", err.response.data.error_description);
          //});
          //router.push("/signin");
        } else {
          let errorText = "";
          let arrayFailed = [];
          if (typeof res.data.message === "object") {
            arrayFailed = Object.entries(res.data.message).map((arr) => ({
              fieldName: arr[0],
              message: arr[1],
            }));
            arrayFailed.forEach((val) => {
              errorText = errorText + val.message + "<br>";
            });
          } else {
            errorText = res.data.message;
          }

          Toast.fire({
            icon: "Error",
            title: errorText,
          });
        }
      });
      // .catch((err) => {
      //   this.loading = false;
      //   // this.msg = err.response.data.message.error;
      //   // this.classAlert = "danger";
      //   console.log(err.status);
      //   Toast.fire({
      //     icon: "Error",
      //     title: err.response,
      //   });
      // });
      //axios
    },
  },
  components: {
    Alert,
    Registerlayout,
    VueSimpleSuggest,
  },
};
</script>

<style>
</style>